import React from 'react';
import { NavLink } from 'react-router-dom';

function TopBar({
    onMenuClick,
    title,
    actions,
    navLinks = [],
    countdownValue,
    countdownVariant = 'countdown',
    showSwitcher,
}) {
    return (
        <header className="topbar">
            <div className="topbar-left">
                {navLinks.length > 0 && (
                    <button
                        className="menu-button"
                        aria-label="Navigation öffnen"
                        onClick={onMenuClick}
                    >
                        ☰
                    </button>
                )}
                <div className="brand" aria-label={title || 'Project Q'}>
                    {title || 'Project Q'}
                </div>
            </div>

            {navLinks.length > 0 && (
                <nav className="topbar-nav" aria-label="Hauptnavigation">
                    <ul>
                        {navLinks.map((link) => (
                            <li key={link.to}>
                                <NavLink to={link.to} className={({ isActive }) => isActive ? 'active' : ''}>
                                    {link.label}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}

            <div className="topbar-actions">
                {showSwitcher}
                {countdownValue !== null && countdownValue !== undefined && (
                    <div
                        className={`countdown-badge ${countdownVariant === 'prediction' ? 'prediction' : ''}`}
                        aria-live="polite"
                    >
                        {Math.max(0, Math.ceil(countdownValue))}
                    </div>
                )}
                {actions}
            </div>
        </header>
    );
}

export default TopBar;
